import React from "react";
import { IoCheckmarkCircle, IoCloseCircle } from "react-icons/io5";
import { FaCircle, FaExclamationCircle } from "react-icons/fa";
import profileIcon from "../../../../Assets/DashboardAssets/profileIcon.png";
import { useSelector } from "react-redux";
import { Empty, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Utility to get the number of days in a month
const getDaysInMonth = (month) => {
  return new Date(new Date().getFullYear(), month, 0).getDate();
};

const AttendanceTable = () => {
  const { monthlyAttendance, filters, loading } = useSelector(
    (state) => state.admin.staffAttendance
  );
  const { month } = filters;
  const { t } = useTranslation("admClass");
  const navigate = useNavigate()
  const transformData = (monthlyAttendance) => {
    const daysInMonth = getDaysInMonth(month);
    const staffs = {};

    monthlyAttendance.forEach((record) => {
      const { staffId, name, employeeID, profile, attendanceStatus } =
        record;

      if (!staffs[staffId]) {
        staffs[staffId] = {
          staffId,
          name,
          employeeID,
          profile,
          attendance: Array(daysInMonth).fill("-"), // Default to "-"
          total: { present: 0, absent: 0, late: 0, leave: 0 }, // Initialize counters
        };
      }

      attendanceStatus.forEach(({ date, status }) => {
        const day = new Date(date).getDate() -1; // Get the day of the month (0-indexed)
        staffs[staffId].attendance[day] = getStatusIcon(status);
        staffs[staffId].total[status]++;
      });
    });

    return Object.values(staffs);
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "leave":
        return <FaCircle className="text-yellow-300" />;
      case "absent":
        return <IoCloseCircle className="text-red-500" />;
      case "late":
        return <FaExclamationCircle className="text-orange-500" />;
      case "present":
        return <IoCheckmarkCircle className="text-green-500" />;
      default:
        return "-";
    }
  };

  const filteredstaffs = transformData(monthlyAttendance);

  if (loading) {
    return (
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-fixed">
          <tbody>
            {[...Array(5)].map((_, index) => (
              <tr key={index}>
                <td className="w-1/4 px-2 py-1 whitespace-no-wrap border-gray-300 border-b">
                  <div className="flex items-center">
                    <Skeleton.Avatar active size="small" shape="circle" />
                    <div className="ms-2">
                      <Skeleton.Input
                        active
                        size="small"
                        style={{ width: 100 }}
                      />
                    </div>
                  </div>
                </td>
                {[...Array(31)].map((_, dayIndex) => (
                  <td
                    key={dayIndex}
                    className="whitespace-no-wrap border-gray-300 border-b text-center"
                    style={{ width: "2%" }}
                  >
                    <Skeleton.Avatar active size="small" shape="circle" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      {filteredstaffs?.length > 0 ? (
        <table className="min-w-full bg-white table-fixed">
          <thead>
            <tr>
              <th className="w-1/4 px-2 py-3 bg-gray-50 text-start font-semibold text-sm leading-4 text-gray-600 uppercase tracking-wider">
                {t("Staff ID / Name")}
              </th>
              {[...Array(getDaysInMonth(month)).keys()]?.slice(0,[...Array(getDaysInMonth(month)).keys()].length-1)?.map((day) => (
                <th
                  key={day}
                  className="w-1/31 py-3 bg-gray-50 font-normal text-center text-sm leading-4 text-gray-600 uppercase tracking-wider"
                  style={{ width: "2%" }}
                >
                  {day+1}
                </th>
              ))}
              <th
                  key={[...Array(getDaysInMonth(month)).keys()].at(-1)+1}
                  className="w-1/31 py-3 bg-gray-50 font-normal text-center text-sm leading-4 text-gray-600 uppercase tracking-wider"
                  style={{ width: "2%" }}
                >
                  {[...Array(getDaysInMonth(month)).keys()].at(-1)+1}
                </th>
            </tr>
          </thead>
          <tbody>
            {filteredstaffs?.map((staff) => (
              <tr key={staff.staffId}>
                <td className="w-1/4 px-2 py-2 whitespace-no-wrap border-gray-300 border-b">
                  <div className="flex items-center"  onClick={()=>navigate(`/Staff-Individual-Attendance/${staff.staffId}`)} style={{cursor:"pointer"}}>
                    <div className="flex-shrink-0 h-10 w-10">
                      <img
                        className="h-10 w-10 rounded-full"
                       
                        src={staff.profile || profileIcon}
                        alt={`${staff.firstName} ${staff.lastName}`}
                      />
                    </div>
                    <div className="ms-2">
                      <div className="text-sm leading-5 font-medium text-gray-500">
                        {staff.name}
                      </div>
                      <div className="text-sm leading-5 text-gray-500">
                        {staff.employeeID}
                      </div>
                    </div>
                  </div>
                </td>
                {staff?.attendance?.map((status, index) => (
                  <td
                    key={index}
                    className="whitespace-no-wrap border-gray-300 border-b text-center"
                    style={{ width: "2%" }}
                  >
                    <div className="flex justify-center items-center">
                      {status}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <Empty description={t("No attendance records found for the selected filters.")} />
      )}
    </div>
  );
};

export default AttendanceTable;
